import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import sanitizeStructuredData from '@sparta.global.utilities/sanitize-structured-data/dist/es6.js';
import { meta } from '@sparta.global.helpers/meta-helper/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"global-structured-data\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"structuredData") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":46},"end":{"line":1,"column":76}}}))
    + "\"></div>\r\n\r\n<div class=\"data-source-jcr\" id=\"sgt0\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt0") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":3,"column":49},"end":{"line":3,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt1\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":4,"column":49},"end":{"line":4,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt2\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt2") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":5,"column":49},"end":{"line":5,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt3\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt3") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":6,"column":49},"end":{"line":6,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt4\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt4") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":7,"column":49},"end":{"line":7,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt5\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt5") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":8,"column":49},"end":{"line":8,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt6\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt6") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":9,"column":49},"end":{"line":9,"column":62}}}))
    + "\"></div>\r\n<div class=\"data-source-jcr\" id=\"sgt7\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sgt7") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":10,"column":49},"end":{"line":10,"column":62}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.my-merrill-login.modules/semantic-markup-runtime-module",
  "version": "1.0.0",
  "id": "semanticMarkupRuntimeModule",
  "containerID": "myMerrillLoginSemanticMarkupRuntimeModule",
  "moduleName": "my-merrill-login-semantic-markup-runtime-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "semantic-markup-runtime-module",
  "data": {
    "init": "semanticMarkupRuntimeModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "useGlobalStructuredData",
    "type": "Boolean",
    "default": false,
    "description": "use Sparta's built-in global structured data object"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    json
  },
  "dependencies": {
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/meta-helper": "^1.0.2",
    "@sparta.global.utilities/sanitize-structured-data": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8"
  },
  "stores": []
};

// this file was created by default via Transmogrify

/**
 * @export
 * @class semanticMarkupRuntimeModule
 * @extends {Module}
 */
class semanticMarkupRuntimeModule extends Module {
  /**
   * Creates an instance of semanticMarkupRuntimeModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof semanticMarkupRuntimeModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Used to decode html entities
    this.cachedDiv = document.createElement('div');
  }

  /**
   * @returns {void}
   */
  init() {
    if (this.params.useGlobalStructuredData) {
      const globalStructureDataEl = this.settings.target.querySelector('.global-structured-data');
      const globalStructuredData = JSON.parse(globalStructureDataEl.dataset.jcr);
      this.createSemanticMarkupScriptTags(globalStructuredData, true);
    }
    this.Events.sub('orchestrationModule.loadStructuredData', ({
      data
    }) => {
      const jcr = this.getSegmentMetaJcr(data);
      this.createSemanticMarkupScriptTags(jcr.structuredData);
      this.createSeoMetaTags(jcr);
    }, true);
  }

  /**
   * Create script tag for each object in structuredData. Appends the script tag to the module div
   * @param {Object} structuredData object from shield meta
   * @param {Boolean} isGlobal is the structuredData Object global structured data?
   * @returns {undefined}
   */
  createSemanticMarkupScriptTags(structuredData, isGlobal = false) {
    if (!structuredData) return;
    Object.keys(structuredData).forEach(key => {
      const structuredDataObj = sanitizeStructuredData(structuredData[key]);
      const scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      if (!isGlobal) {
        scriptEl.classList.add('page-specific-semantic-markup');
      }
      scriptEl.appendChild(document.createTextNode(structuredDataObj));
      document.head.appendChild(scriptEl);
    });
  }

  /**
   * @description Creates and appends meta tags to the document head
   *
   * @param {Object} seoJson OET
   * @returns {undefined}
   */
  createSeoMetaTags(seoJson) {
    this.cachedDiv.innerHTML = meta(seoJson);
    while (this.cachedDiv.childNodes.length > 0) {
      document.head.appendChild(this.cachedDiv.childNodes[0]);
    }
  }

  /**
   * @description gets jcr for the current segment
   *
   * @param {Number} segment current page segment
   * @return {Object} segment meta JCR
   */
  getSegmentMetaJcr(segment) {
    const jcr = JSON.parse(this.settings.target.querySelector(`#sgt${segment}`).dataset.jcr);
    delete jcr.jcr;
    return jcr;
  }
}
registerModuleClass({
  moduleClass: semanticMarkupRuntimeModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { semanticMarkupRuntimeModule as default, moduleConfig };
